'use strict';

import { addEvent } from './addEvent/addEvent';
import { mainPageBaner } from './mainPageBaner/mainPageBaner';
import { fslightboxInit } from './fslightbox/fslightbox';
import { tableWrapperInit } from './tableWrapper/tableWrapper';

document.addEventListener('DOMContentLoaded', () => {
  window.mainPagebaner = new mainPageBaner(
    document.getElementsByClassName('main-page-baner')
      ? document.getElementsByClassName('main-page-baner')[0]
      : null
  );

  if (window.mainPagebaner) window.mainPagebaner.init();
  if (window.mainPagebaner) window.mainPagebaner.start();

  fslightboxInit();
  tableWrapperInit();
});

addEvent(window, 'load', () => {});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});
